const BaseIntegrationMixin = {
  methods: {
    /**
     * actions before redirect user to registration screen
     */
    getPreRegistrationRedirectionActionImpl() {
      return () => {
        this.$router.push('register1'); // no actions by default, go to register 1 immediately
      };
    },
    /**
     * check url parameters and do appropriate actions based on them
     */
    getIntegrationParametersCheckImpl() {
      return (to) => {
        this.proceedToAutoLogin(to); // check for auto-login parameters
        // eslint-disable-next-line
        console.log(`No parameter check ( parameters: ${to.query} ) for active integration: ${this.getIntegrationConfig.integrationKey}`);
      };
    },

    // ----------- request/verify methods -------------------------------
    /**
     * alternate request pin process
     */
    getAlternateRequestPinActionImpl() {
      return null; // default integration follows standard request pin process
    },
    /**
     * alternate verify pin process
     */
    getAlternateVerifyPinActionImpl() {
      return null; // default integration follows standard verify pin process
    },

    // ----------- reSub/unSub methods ----------------------------------
    /**
     * actions after successful unsubscription
     */
    getPostUnSubActionImpl() {
      return () => {
        // eslint-disable-next-line
        console.log(`No action needed for active integration: ${this.getIntegrationConfig.integrationKey}`);
      };
    },
    /**
     * alternate re-subscription process
     */
    alternateReSubActionImpl() {
      return () => {
        // eslint-disable-next-line
        console.log(`No reSub action check for active integration: ${this.getIntegrationConfig.integrationKey}`); // default integration follows standard resub process
      };
    },

    // ------------- forgotPin methods --------------------------------------
    /**
     * alternate forgot pin (1st step - request pin) process
     */
    alternateForgotProcessImpl() {
      return () => {
        // eslint-disable-next-line
        console.log(`No alternate forgot pin for active integration: ${this.getIntegrationConfig.integrationKey}`);
      };
    },
    /**
     * alternate forgot pin (2nd step - verify pin) process
     */
    alternateForgotVerifyPinProcessImpl() {
      return () => {
        // eslint-disable-next-line
        console.log(`No alternate forgot verify pin for active integration: ${this.getIntegrationConfig.integrationKey}`);
      };
    },
    checkIfIsOnly2Step() {
      return false;
    },
  },
};

export default BaseIntegrationMixin;



// WEBPACK FOOTER //
// ./src/common/mixins/integrations/baseIntegration.js